module.exports = __webpack_public_path__ + "static/media/pexels5.dfb3edd6.jpg";